import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/_services/loader.service';

@Component({
    selector: 'app-loader',
    standalone: false,
    templateUrl: './loader.component.html',
})

export class LoaderComponent {

    isLoading = false;
    private subscription: Subscription;

    constructor(private loaderService: LoaderService) {
        this.subscription = this.loaderService.loaderState$.subscribe((state:any) => {
            this.isLoading = state;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}

